<template>
  <div>
    <list
      row-key="UserId"
      ref="list"
      unit="学校信息管理"
      :expand-all-row="true"
      :page="page"
      :query-params="params"
      :show-checkbox="showCheckbox"
      :show-query="false"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        
      </template>
      <template slot="table">
        <el-table-column prop="Sn" label="序号"/>
        <el-table-column prop="SchoolName" label="学校名称"/>
        <el-table-column prop="BannerUrl" label="展示图片" align="center" min-width="170">
          <template slot-scope="{row}">
            <el-image :src="'/api' + row.BannerUrl" :preview-src-list="['/api' + row.BannerUrl]" style="width: 160px; height: 90px" v-if="row.BannerUrl"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="QrCodeUrl" label="二维码" align="center" min-width="100">
          <template slot-scope="{row}">
            <el-image :src="'/api' + row.QrCodeUrl" :preview-src-list="['/api' + row.QrCodeUrl]" style="width: 90px; height: 90px" v-if="row.QrCodeUrl"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="Status" label="状态" width="90" align="center">
          <template slot-scope="{row}">
            <el-tag type="success" v-if="row.Status==1" size="small">启用</el-tag>
            <el-tag type="danger" v-else-if="row.Status==0" size="small">禁用</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="EnableMini" label="小程序" width="90" align="center">
          <template slot-scope="{row}">
            <el-tag type="success" v-if="row.EnableMini==1" size="small">启用</el-tag>
            <el-tag type="danger" v-else-if="row.EnableMini==0" size="small">停用</el-tag>
          </template>
        </el-table-column>
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/st/school").default,
      params: {
        SchoolName: "",
      },
    };
  },
  methods: {
    export() {
      this.$refs.exportDialog.open().then((that) => {
        that.getData(this.params);
      });
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error("删除失败，" + res.Msg);
        }
      });
    },
  },
};
</script>